<template>
	<div class='flex w-full min-h-full bg-grey absolute inset'>
		<div class='min-h-full shrink-0 xl:max-w-[700px] w-full overflow-scroll flex flex-col justify-between'>
			<slot />

			<div class='text-12 xs:text-14 text-grey-900 text-center lg:mt-10 pb-10'>
				<p>©{{ $moment().format('YYYY') }} Get Work Limited. All rights reserved.</p>
				<p class='mt-2'>
					<a href='https://www.zapo.com/terms-and-conditions' class='link-black' target="_blank">Terms</a> / <a class='link-black' href='https://www.zapo.com/privacy-policy' target="_blank">Privacy</a>
				</p>
			</div>
		</div>

		<div class='bg-white w-full hidden flex-col justify-between items-center xl:flex'>
			<div class='pt-14 px-16 w-full h-6'>
				<div class="trustpilot-widget" data-locale="en-US" data-template-id="5406e65db0d04a09e042d5fc" data-businessunit-id="5dde7b1cd5594d0001d706fa" data-style-height="28px" data-style-width="100%" data-token="415cc76b-90e6-4f10-8f3d-667224a568e7">
					<a href="https://www.trustpilot.com/review/getwork.co.uk" target="_blank" rel="noopener">Trustpilot</a>
				</div>
				<!-- <a href="https://uk.trustpilot.com/review/getwork.co.uk?utm_medium=Trustbox&utm_source=app.zapo.com" target="_blank" rel="noopener noreferrer"  class='flex items-center gap-2'>
					<img class='h-6' src='https://emailsignature.trustpilot.com/signature/en-GB/4/5dde7b1cd5594d0001d706fa/text.png' />
					<img class='h-6' src='https://emailsignature.trustpilot.com/newsletter/en-GB/2/5dde7b1cd5594d0001d706fa/stars.png' />
					<img class='h-4.5' src='https://emailsignature.trustpilot.com/signature/en-GB/2/5dde7b1cd5594d0001d706fa/text.png' />
					<img class='h-[20px] mt-[-2px]' src='https://emailsignature.trustpilot.com/brand/s/4/logo.png' />
				</a> -->
			</div>

			<div class='max-w-[520px]'>
				<p class='text-hero font-hero font-bold mb-10'>Grow your business with Get Work</p>

				<div class='flex items-center'>
					<IconTrue class='h-7 w-7 stroke-green-600 mr-4 w-7 h-7 bg-green-500 bg-opacity-10 rounded-full' />
					<p class='text-base'>Over £600m in leads sent to UK businesses</p>
				</div>

				<div class='flex items-center mt-4'>
					<IconTrue class='h-7 w-7 stroke-green-600 mr-4 w-7 h-7 bg-green-500 bg-opacity-10 rounded-full' />
					<p class='text-base'>Sign up, receive leads, it’s that simple</p>
				</div>

				<div class='flex items-center mt-4'>
					<IconTrue class='h-7 w-7 stroke-green-600 mr-4 w-7 h-7 bg-green-500 bg-opacity-10 rounded-full' />
					<!-- <p class='text-base'>Manage your leads in Zapo CRM</p> -->
					<p class='text-base'>FREE lead management platform</p>
				</div>
			</div>

			<!-- :style='{ height: square+"px" }' -->
			<div class='w-full flex h-[92px]' ref='squareHolder'>
				<!-- <div class='bg-red-600 rounded-tr-50 w-full h-full' />
				<div class='bg-green-500 rounded-tl-50 w-full h-full' />
				<div class='bg-red-500 rounded-tl-50 rounded-br-50 w-full h-full' />
				<div class='bg-grey rounded-tr-50 w-full h-full' />
				<div class='bg-red-600 rounded-tl-50 w-full h-full' />
				<div class='bg-purple-600 rounded-tr-50 rounded-bl-50 w-full h-full' />
				<div class='bg-grey rounded-tr-50 w-full h-full' />
				<div class='bg-green-500 rounded-tl-50 w-full h-full' />
				<div class='bg-green-600 rounded-tl-50 rounded-br-50 w-full h-full' /> -->
			</div>
		</div>
	</div>
</template>

<script>
	import MasterLayoutMixin from '~/mixins/master-mixin.js'

	export default {
		mixins: [MasterLayoutMixin],

		setup() {
			useHead({
				script: [{ 
					src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', defer: true 
				}]
			})
		},

		mounted() {
			this.squareSize()

			window.addEventListener("resize", this.squareSize);
		},
		
		unmounted() {
			window.removeEventListener("resize", this.squareSize);
		},

		data() {
			return {
				square: 100
			}
		},

		methods: {
			squareSize() {
				this.square = (this.$refs.squareHolder.clientWidth / 9).toFixed(2);
			}
		},
	}
</script>